export default [
    {
        label: 'Requested Funding Amount',
        type: 'number',
        model: 'loan_amount',
        placeholder: 'Funding Amount',
        rules: 'required|numeric|max:9999999'
    },
    {
        label: 'Intended Use of Funds',
        type: 'text',
        model: 'loan_intent',
        placeholder: 'Use Of Funds',
        rules: 'required|alpha_spaces|max:100'
    },
    {
        label: 'Business Name',
        type: 'text',
        model: 'business_legal_name',
        placeholder: 'Business Name',
        rules: 'required|max:100'
    },
    {
        label: 'Business Start Date',
        type: 'date',
        model: 'date_established',
        placeholder: null,
        rules: 'required'
    },
    {
        label: 'First Name',
        type: 'text',
        model: 'first_name',
        placeholder: 'First Name',
        rules: 'required|max:100'
    },
    {
        label: 'Last Name',
        type: 'text',
        model: 'last_name',
        placeholder: 'Last Name',
        rules: 'required|max:100'
    },
    {
        label: 'Email',
        type: 'email',
        model: 'email',
        placeholder: 'Email',
        rules: 'required|email'
    },
    {
        label: 'Cell Phone',
        type: 'text',
        model: 'cell_phone',
        placeholder: 'Cell Phone',
        rules: 'required|digits:10'
    },
    {
        label: 'Province',
        type: 'select',
        model: 'state',
        placeholder: 'Select Province',
        rules: 'required',
        options: [
            {
                name: 'Alberta',
                value: 'AB'
            },
            {
                name: 'British Columbia',
                value: 'BC'
            },
            {
                name: 'Manitoba',
                value: 'MB'
            },
            {
                name: 'New Brunswick',
                value: 'NB'
            },
            {
                name: 'Newfoundland and Labrador',
                value: 'NL'
            },
            {
                name: 'Nova Scotia',
                value: 'NS'
            },
            {
                name: 'Ontario',
                value: 'ON'
            },
            {
                name: 'Prince Edward Island',
                value: 'PE'
            },
            {
                name: 'Quebec',
                value: 'QC'
            },
            {
                name: 'Saskatchewan',
                value: 'SK'
            },
            {
                name: 'Northwest Territories',
                value: 'NT'
            },
            {
                name: 'Nunavut',
                value: 'NU'
            },
            {
                name: 'Yukon Territory',
                value: 'YT'
            }
        ]
    },
    {
        label: 'Average Monthly Sales (deposits)',
        type: 'select',
        model: 'average_monthly_sales',
        placeholder: 'Select Average Monthly Sales',
        rules: 'required',
        options: [
            {
                name: 'Startup Funding - FICO 700+',
                value: 'Startup Funding - FICO_700'
            },
            {
                name: '$5,000 - $10,000',
                value: '$5,000 - $10,000'
            },
            {
                name: '$10,001 - $20,000',
                value: '$10,001 - $20,000'
            },
            {
                name: '$20,001 - $50,000',
                value: '$20,001 - $50,000'
            },
            {
                name: '$50,001 - $100,000',
                value: '$50,001 - $100,000'
            },
            {
                name: '$100,001 +',
                value: '$100,001 +'
            }
        ]
    },
    // {
    //     label: 'Average Monthly Sales (volume)',
    //     type: 'select',
    //     model: 'total_monthly_sales',
    //     placeholder: 'Select Average Monthly Sales (volume)' ,
    //     rules: 'required',
    //     options: [
    //         {
    //             name: 'Startup Financing - FICO 690+',
    //             value: 'Startup Financing - FICO 690+'
    //         },
    //         {
    //             name: '$4,166 - $10,000',
    //             value: '$4,166 - $10,000'
    //         },
    //         {
    //             name: '$10,001 - $25,000',
    //             value: '$10,001 - $25,000'
    //         },
    //         {
    //             name: '$25,001 - $65,000',
    //             value: '$25,001 - $65,000'
    //         },
    //         {
    //             name: '$65,001 - $120,000',
    //             value: '$65,001 - $120,000'
    //         },
    //         {
    //             name: '$120,000 +',
    //             value: '$120,000 +'
    //         }
    //     ]
    // },
    {
        label: 'Credit Score',
        type: 'select',
        model: 'credit_score',
        placeholder: 'Select Credit Score',
        rules: 'required',
        options: [
            {
                name: 'Excellent 740 - 850',
                value: 'Excellent 740 - 850'
            },
            {
                name: 'Good 680 - 739',
                value: 'Good 680 - 739'
            },
            {
                name: 'Fair 620-679',
                value: 'Fair 620-679'
            },
            {
                name: 'Poor 550-619',
                value: 'Poor 550-619'
            },
            {
                name: 'Bad 300-549',
                value: 'Bad 300-549'
            }
        ]
    }
];
